module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAAHlBMVEUAAABmdYpgcI9odolmdotndopndopmdolndYpndootU8WhAAAACXRSTlMA7xCAf+riUEj6YGIAAAAAlUlEQVQ4y+3PsQmAMBCFYckKClpmBQsHsHACBXEESwsHcAiF29YQfZzxpRPBwhQh/B+Eu+TJMU1no70WyWy8Q7h74Z6WXrhbAwm7C6dQV7l1FepXmbSr5O4xaFdZD+DZt+Mrnj1PXptdeyjUIWGfOwtBN03v7lEyCHotmweIdg+LQKoWXYp/889tfhF0EnSSWMfmD84Obf+4nn6LBzEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplychain/layers.png
// module id = RmmC
// module chunks = 44